import { type ReactNode } from 'react';
import styles from './QuizToast.module.css';

type Props = {
  testid?: string;
  children: ReactNode;
  icon: ReactNode;
};

export function QuizToast(props: Props) {
  const { testid, children, icon } = props;

  return (
    <div data-testid={`${testid}`} className={styles.container}>
      {icon}
      {children}
    </div>
  );
}
